import { graphql } from '../../../../graphql/generated';

export const CATALOG_QUERY = graphql(`
  query Catalog($catalogId: ID!) {
    catalog(id: $catalogId) {
      id
      name
      description
      catalogParameters {
        id
        parameter {
          id
        }
      }
    }
  }
`);

export const UPDATE_CATALOG_MUTATION = graphql(`
  mutation UpdateCatalog($id: ID!, $input: CatalogUpdateInput!) {
    updateCatalog(id: $id, input: $input) {
      id
    }
  }
`);
